// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../reason/next/Next.bs.js");
var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Scalars = require("../../scalars/Scalars.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var IsNewQueryParam = require("./IsNewQueryParam.bs.js");
var RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var TeamMarketingProfileAboutSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileAboutSettingsQuery_graphql.bs.js");
var TeamMarketingProfileAboutSettingsMutation_graphql = require("../../__generated__/TeamMarketingProfileAboutSettingsMutation_graphql.bs.js");
var TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.bs.js");

var convertFragment = TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileAboutSettings_form_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = TeamMarketingProfileAboutSettingsMutation_graphql.Internal.convertVariables;

var convertResponse = TeamMarketingProfileAboutSettingsMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = TeamMarketingProfileAboutSettingsMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

var validators = {
  about: undefined
};

function initialFieldsStatuses(_input) {
  return {
          about: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            about: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, param, param$1) {
  var match = {
    TAG: "Ok",
    _0: input.about
  };
  if (match.TAG === "Ok") {
    return {
            TAG: "Valid",
            output: {
              about: match._0
            },
            fieldsStatuses: {
              about: {
                TAG: "Dirty",
                _0: match,
                _1: "Hidden"
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: "Invalid",
            fieldsStatuses: {
              about: {
                TAG: "Dirty",
                _0: match,
                _1: "Hidden"
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurAboutField" :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.about, state.fieldsStatuses.about, (function (status) {
                          return {
                                  about: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateAboutField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.about, (function (status) {
                                    return {
                                            about: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                about: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                about: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateAbout: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateAboutField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurAbout: (function () {
              dispatch("BlurAboutField");
            }),
          aboutResult: Formality.exposeFieldResult(state.fieldsStatuses.about),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.about;
              if (typeof tmp !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function initialInputFromFragment(fragment) {
  return {
          about: fragment.about
        };
}

function TeamMarketingProfileAboutSettings$Form$RichTextField(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                            labelText: props.labelText
                          }),
                      className: "pt-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(RichTextEditorV5.make, {
                              initialContent: props.initialValue,
                              onChange: props.onChange,
                              onBlur: props.onBlur,
                              toolbar: "withSingleHeadingLevel",
                              proseStyle: "md"
                            }),
                        Core__Option.getOr(Core__Option.map(props.helpText, (function (text) {
                                    return JsxRuntime.jsx("div", {
                                                children: text,
                                                className: "text-base text-gray-500"
                                              });
                                  })), null)
                      ],
                      className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3"
                    })
              ],
              className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
            });
}

var RichTextField = {
  make: TeamMarketingProfileAboutSettings$Form$RichTextField
};

function TeamMarketingProfileAboutSettings$Form(props) {
  var marketingProfile = use(props.marketingProfile);
  var match = use$1();
  var mutate = match[0];
  var match$1 = IsNewQueryParam.use();
  var isNew = match$1[0];
  var router = Next.useRouter();
  var subpages = MarketingProfileSubpages.useTeamProfilePages(undefined, undefined);
  var nextPage = Core__Option.flatMap(Core__Array.findIndexOpt(subpages, (function (param) {
              return param.page === "About";
            })), (function (i) {
          return subpages[i + 1 | 0];
        }));
  var form = useForm(initialInputFromFragment(marketingProfile), (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          mutate({
                input: {
                  about: param.about
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var result = param.updateTeamMarketingProfileAboutSection;
                  if (result === undefined) {
                    return notifyOnFailure();
                  }
                  if (result.__typename !== "TeamMarketingProfileAboutSectionUpdated") {
                    return notifyOnFailure();
                  }
                  notifyOnSuccess(undefined);
                  if (isNew && nextPage !== undefined) {
                    return Next.Router.push(nextPage.path + "?is_new=1", undefined, undefined, router);
                  }
                  
                }), (function (param) {
                  notifyOnFailure();
                }), undefined);
        }));
  var match$2 = form.status;
  var tmp;
  tmp = typeof match$2 !== "object" ? (
      match$2 === "Editing" ? null : (function (__x) {
              return ReactRender.ifTrue(JsxRuntime.jsx(Alert.Success.make, {
                              title: "Your account was updated"
                            }), __x);
            })(!isNew)
    ) : (
      match$2.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Alert.$$Error.make, {
                    title: "There was an error updating your account. Please try again"
                  }),
              className: "mt-4"
            })
    );
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(TeamMarketingProfileAboutSettings$Form$RichTextField, {
                                  onChange: (function (value) {
                                      form.updateAbout((function (_input, value) {
                                              return {
                                                      about: value
                                                    };
                                            }), value);
                                    }),
                                  onBlur: (function (param) {
                                      form.blurAbout();
                                    }),
                                  initialValue: marketingProfile.about,
                                  labelText: "About your team"
                                }),
                            className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    href: Scalars.$$URL.toString(marketingProfile.publicUrl),
                                    target: "_blank",
                                    children: "View Profile"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                            disabled: form.submitting,
                                            children: Caml_option.some(isNew ? "Save and continue" : "Save changes")
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: tmp,
                                            role: "status"
                                          })
                                    ],
                                    className: "flex flex-col items-end gap-3"
                                  })
                            ],
                            className: "flex justify-between items-baseline"
                          })
                    ],
                    className: "space-y-6"
                  }),
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  form.submit();
                })
            });
}

var Form = {
  Fragment: Fragment,
  Mutation: Mutation,
  Config: Config,
  initialInputFromFragment: initialInputFromFragment,
  RichTextField: RichTextField,
  make: TeamMarketingProfileAboutSettings$Form
};

function TeamMarketingProfileAboutSettings$Header(props) {
  var displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  var breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("About"),
      href: MarketingProfileSubpages.Page.Team.path("About")
    }
  ];
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(Breadcrumbs.make, {
                      pages: breadcrumbs
                    }),
                JsxRuntime.jsx("h2", {
                      children: "About your team",
                      className: "text-zinc-800 text-3xl font-medium"
                    })
              ],
              className: "space-y-3 border-b pb-2"
            });
}

var Header = {
  make: TeamMarketingProfileAboutSettings$Header
};

var convertVariables$1 = TeamMarketingProfileAboutSettingsQuery_graphql.Internal.convertVariables;

var convertResponse$1 = TeamMarketingProfileAboutSettingsQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = TeamMarketingProfileAboutSettingsQuery_graphql.Internal.convertWrapRawResponse;

var use$2 = RescriptRelay_Query.useQuery(convertVariables$1, TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1);

var useLoader = RescriptRelay_Query.useLoader(convertVariables$1, TeamMarketingProfileAboutSettingsQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

var fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

var retain = RescriptRelay_Query.retain(TeamMarketingProfileAboutSettingsQuery_graphql.node, convertVariables$1);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileAboutSettings(props) {
  var match = use$2(undefined, undefined, undefined, undefined);
  var marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TeamMarketingProfileAboutSettings$Header, {}),
                        JsxRuntime.jsx(TeamMarketingProfileAboutSettings$Form, {
                              marketingProfile: marketingProfile.fragmentRefs
                            })
                      ],
                      className: "space-y-8 sm:space-y-0"
                    }),
                className: "bg-white p-6 shadow-sm rounded space-y-8"
              });
  } else {
    return UnselectedUnionMemberError.raise("Unselected union member: " + marketingProfile._0);
  }
}

var make = TeamMarketingProfileAboutSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
